export default __webpack_public_path__ + "static/media/admob-300x250.9e0696a5.png";